import React from 'react';
import AppShell from '../components/layout/AppShell';
import MyPostings from '../features/opportunities/components/MyPostings';

const MyPostingsPage = () => {
  return (
    <AppShell>
      <MyPostings />
    </AppShell>
  );
};

export default MyPostingsPage;
